
angular.module('qms.services', [])

.factory("Compare", [function() {

			var service = {}

			service.objEquiv = function(a, b) {

				var aProps = Object.getOwnPropertyNames(a);
				var bProps = Object.getOwnPropertyNames(b);

				if (aProps.length != bProps.length) {
					return false;
				}

				for (var i = 0; i < aProps.length; i++) {
					var propName = aProps[i];
					if (a[propName] !== b[propName]) {
						return false;
					}
				}

				return true;
			}

			return service;

		}])

.factory("ApiSvce", ['$http',function($http) {

					var apiUrl = window.location.protocol + "//" + window.location.hostname + window.location.pathname;
					var service = {}

					service.getApiUrl = function(url) {
						return apiUrl;
					}

					service.setApiUrl = function(url) {
						apiUrl = url;
						return apiUrl;
					}

					service.existsAtApi = function(f) {
						return $http.get(apiUrl+f);
						return true;
					}

					service.exists = function(f) {
						return $http.get(f);
						return true;
					}

					service.get = function(url) {
						return $http.get(url);
						return true;
					}

					service.post = function(url,data,config) {
						const d = JSON.stringify(data);
						const conf = (typeof config !== 'undefined' && config) ? config : false;
						if(conf) {
							return $http.post(url,d,conf);
						}
						else {
							return $http.post(url,d);
						};
						return true;
					}

					service.getJson = function(url,fName) {
						return $http.get(url+fName);
						return true;
					}

					return service;

			}])


.factory('ArraySvce',['$rootScope',function($rootScope) {

			var service = {};

			service.arrIndexOf = function(myArray, searchTerm, property) {
				for(var i = 0, len = myArray.length; i < len; i++) {
					if (myArray[i][property] == searchTerm) return i;
				}
				return -1;
			}

			service.arrIndexOfTyped = function(myArray, searchTerm, property) {
				for(var i = 0, len = myArray.length; i < len; i++) {
					if (myArray[i][property] === searchTerm) return i;
				}
				return -1;
			}

			service.copyObj = function(obj) {
				var data = {};
				for(x in obj) {
						data[x] = obj[x];
					}
				return data;
			}

			return service;

		}])


.factory('DataObj',['$rootScope',function($rootScope) {

				var service = {};

				service.sliderDefaults = function() {

					return {
							id: 'slider',
							showMarkers: true,
							markerMin: true,
						  showEndKeys: true,
							showCounter: false,
							showNearKeyLabel: true,
							showCurPercent: false,
							handleColor: '#005095',
							handleInnerColor: '#fff',
							lineColor: '#d9d9d9',
							progressColor: '#005095',
							lineBorder: '#333',
							markerBgColor: '#fff',
							widthPercent: 100,
							justification: 'right',
							steps: 0,
							keyColor: '#fff',
							keySize: '1.1em',
							keyVoffset: '2.6em',
						  keyNames: null,
							maxOffset: 24,
							minOffset: 8,
							boxClasses: 'set_cursor'
						}

				}

				service.sliderState = function() {

					return {
						 id: 0,
						 width: 0,
						 range: 0,
						 curPos: 0,
						 curPercent: 0,
					 	 nearKey: 3,
						 nearKeyLabel: 'R4L',
						 mouseDown: false,
						 touchEvents: {
							 panning:false
						 },
						 loadState: {
							 ready: false
						 }
					 }

				}

				return service;

	}])

	.factory('PreLoader',['$q','$rootScope',function($q, $rootScope) {

			var service = {};

			service.preloadImages = function(imgList) {
				var imgCount = imgList.length;
				var imgs = [];
				var loaded = 0;
				for ( var i = 0 ; i < imgCount ; i++ ) {
					imgs[i] = new Image();
					imgs[i].src = imgList[i];
					imgs[i].addEventListener('load', function() {
						//console.log(this.src + "loaded...");
						loaded++;
						if(loaded >= imgCount) {
							console.log("Initial images preloaded.")
						}
					})
				}
			};

			return service;

		}])

		.factory('LocStore',[function() {

			var service = {};

			service.storage = function() {
				var mod = new Date;
				try {
					localStorage.setItem(mod, mod);
					localStorage.removeItem(mod);
					return true;
				} catch (exception) {
					return false;
				}
			}

			service.set = function(name,data) {
				if(service.storage()) {
					localStorage.setItem(name, JSON.stringify(data));
					return true;
				}
				return false;
			}

			service.clear = function(name) {
				if(service.storage()) {
					localStorage.removeItem(name);
					return true;
				}
				return false;
			}

			service.wipe = function(name) {
				if(service.storage()) {
					localStorage.clear();
					return true;
				}
				return false;
			}

			service.get = function(name) {
				if(service.storage()) {
					var data = JSON.parse(localStorage.getItem(name));
					return data;
				}
				return false;
			}

			service.sessionSet = function(name,data) {
				if(service.storage()) {
					sessionStorage.setItem(name, JSON.stringify(data));
					return true;
				}
				return false;
			}

			service.sessionGet = function(name) {
				if(service.storage()) {

					var data = JSON.parse(sessionStorage.getItem(name));
					return data;
				}
				return false;
			}

			service.sessionClear = function(name) {
				if(service.storage()) {
					localStorage.removeItem(name);
					return true;
				}
				return false;
			}

			return service;

	}]);



// WEBPACK FOOTER //
// ./src/app/js/qms.services.js